/**
 * Created by Kevin Dench on 6/15/2016.
 */
import angular from 'angular';
import ngResource from 'angular-resource';
import CompareApiService from './compare-api.service';
import ContainerInfoApiService from './container-info-api.service';
import DefinitionApiService from './definition-api.service';
import DefinitionParameterApiService from './definition-parameter-api.service';
import DefinitionParameterRangeApiService from './definition-parameter-range-api.service';
import OctopartApiService from './octopart-api.service';
import ParameterApiService from './parameter-api.service';
import PromoSpaceApiService from './promo-space-api.service';
import QueryApiService from './query-api.service';
import SimilarPartsApiService from './similar-parts-api.service';
import UniquePartApiService from './unique-part-api.service';

export default angular.module('APIModule', [ngResource])
    .factory('CompareApiService', CompareApiService)
    .factory('ContainerInfoApiService', ContainerInfoApiService)
    .factory('DefinitionApiService', DefinitionApiService)
    .factory('DefinitionParameterApiService', DefinitionParameterApiService)
    .factory('DefinitionParameterRangeApiService', DefinitionParameterRangeApiService)
    .factory('OctopartApiService', OctopartApiService)
    .factory('ParameterApiService', ParameterApiService)
    //  .factory('ParameterValueApiService', ParameterValueApiService) // Currently not used.
    .factory('PromoSpaceApiService', PromoSpaceApiService)
    .factory('QueryApiService', QueryApiService)
    .factory('SimilarPartsApiService', SimilarPartsApiService)
    .factory('UniquePartApiService', UniquePartApiService)

    .name; // must come last.

